const returnsData = {
    title: "Return Policy",
    updatedDate: "April 1, 2025",
    introduction: [
        "MINDSCLIK through its platform MPERITO provides ability for its customers to launch their branded ecommerce application on web and mobile. As part of the solution few of its customers (businesses) can leverage MINDSCLIK payment gateway to collect money on the purchases made end customer.",
        "The following Return Policy is applicable to the Customers or Businesses that are leveraging the MPERITO platform along with its payment gateway:"
    ],
    sections: [
        {
            title: "Eligibility for Returns",
            subtitle: "",
            content: [
                {
                    type: "bullet",
                    items: [
                        "Any consumable products purchased through the branded app on MPERITO platform are not eligible for return.",
                        "Each of the Businesses will be defining their return policies",
                        "Products purchased through the MPERITO platform are eligible for return within 15 days from the date of delivery.",
                        "To be eligible for a return, items must be unused, in the same condition as received, and in the original packaging.",
                    ]
                },

            ]
        },
        {
            title: "Return Process",
            subtitle: "",
            content: [
                {
                    type: "bullet",
                    items: [
                        "Customers must contact our customer support team to initiate a return request.",
                        "Once the return request is approved, customers will be provided with instructions on how to return the item."
                    ]
                },

            ]
        },
        {
            title: "Return Shipping",
            subtitle: "",
            content: [
                {
                    type: "bullet",
                    items: [
                        "Customers are responsible for the cost of return shipping unless the return is due to a mistake on our part (e.g., wrong item shipped, defective product)." 
                    ]
                },

            ]
        },
        {
            title: "Shipping Address",
            subtitle: "",
            content: [
                {
                    type: "bullet",
                    items: [
                        "Customers are responsible for providing accurate shipping addresses. MINDSCLIK and MPERITO are not liable for any delays or non-delivery due to incorrect address information provided by the customer.",
                    ]
                },

            ]
        },
        {
            title: "Refunds",
            subtitle: "",
            content: [
              
                {
                    type: "bullet",
                    items: [
                        "Customers are responsible for providing accurate shipping addresses. MINDSCLIK and MPERITO are not liable for any delays or non-delivery due to incorrect address information provided by the customer."
                    ]
                },
            ]
        },

        {
            title: "Delivery Issues",
            subtitle: "",
            content: [
                {
                    type: "bullet",
                    items: [
                        "Refunds will be issued to the original payment method within 15 business days of receiving the returned item.",
                        'Shipping costs are non-refundable unless the return is due to a mistake on our part.',                        
                    ]
                },
            ]
        },
        {
            title: "Changes to this Return Policy",
            subtitle: "",
            content: [
                {
                    type: "text",
                    items: [
                        "We may update Our Return Policy from time to time. We will notify You of any changes by posting the new Return Policy on this page.",
                        'We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Return Policy.',
                        "You are advised to review this Return Policy periodically for any changes. Changes to this Return Policy are effective when they are posted on this page."
                    ]
                },
            ]
        },
        {
            title: "Contact Us",
            subtitle: "",
            content: [
                {
                    type: "text",
                    items: [
                        "If you have any questions about this Return Policy, You can contact us:",
                    ]
                },
                {
                    type: "bullet",
                    items: [
                        "By email: support@mindsclik.com",
                    ]
                },

            ]
        },
    ]
};

export default returnsData;

// type = { title | text | bullet | numbered }